import React from "react";
import './AboutMe.scss';
import Typography from '@mui/material/Typography';

const AboutMe = () => {
    return (
        <div className="about-me text-center">

            <img src="./images/icons/woman.png" alt="" className="woman-img" />

            <p className="about-content">
                I love everything that is related to Web programming (React - Firebase, Mern Stack). 
                I'm a motivated developer with experience creating custom websites with ReactJs, JavaScript, HTML5 & CSS3, and MongoDB.
                <br />
                <br />
                I have attended many challenges, Hackathons to brush up my skills. 
                When I'm not coding, texting or developing some site, you'll find me&nbsp;
                <a href="https://drive.google.com/drive/folders/1bJCt6jShwETk754UJccEPz37oVfJVSP7?usp=sharing" target="_blank" className="drawing-link">drawing</a> 
                &nbsp;or gaming. I love art 🎨 .
            </p>

            <Typography variant="h6" gutterBottom component="div" className="text-center">
                🎯 Skills I possess
            </Typography>

            <ul className="skills">
                <li>DataStructures, Algorithms</li>
                <li>Languages - Java</li>
                <li>Developement - MERN stack</li>
                <li>Databases - MongoDb, Firebase, MySQL</li>
                <li>Tools - Git, Postman</li>
            </ul>
        </div>
    )
}

export default AboutMe;